import { Component } from 'react';
import { shape, string } from 'prop-types';
import withRouter from '../WithRouter';

class ScrollToTop extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    return null;
  }
}

ScrollToTop.defaultProps = {
  location: {
    pathname: ''
  }
};

ScrollToTop.propTypes = {
  location: shape({
    pathname: string.isRequired
  })
};

export default withRouter(ScrollToTop);
